import {
    Cancel,
    CheckCircle,
    ContentCopy,
    KeyboardArrowDown,
    KeyboardArrowUp,
} from '@mui/icons-material'
import {
    Box,
    Button,
    Collapse,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TextField,
    Typography,
} from '@mui/material'
import moment from 'moment'
import { Fragment, useEffect, useState } from 'react'
import { getValidationLogs } from '../../services/claimsService'

interface ValidationSummaryProps {
    entry: any
    close: () => void
    open: boolean
}

export const ValidationSummaryDialog = ({ entry, open, close }: ValidationSummaryProps) => {
    const [logs, setLogs] = useState<any[]>()
    const [expand, setExpand] = useState('')
    useEffect(() => {
        if (entry?.claimNumber !== '') {
            Promise.all([getValidationLogs(entry?.claimNumber)])
                .then(async ([response]) => {
                    setLogs(await response.data)
                })
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                .catch((err: Error) => {
                    // TO DO
                })
        }
    }, [entry])

    const closeEvent = () => {
        close()
    }

    const copyToClipboard = (value: string) => {
        navigator.clipboard.writeText(value)
    }

    if (logs === undefined) {
        return <></>
    }
    return (
        <Dialog open={open} onClose={close} maxWidth="lg">
            <DialogTitle>Validation Summary</DialogTitle>
            <DialogContent>
                <Box style={{ display: 'flex', flexDirection: 'column', width: '640px' }}>
                    <TextField
                        size="small"
                        fullWidth
                        style={{ backgroundColor: 'white', marginTop: '30px' }}
                        disabled
                        label="Message Type"
                        value={entry?.messageType}
                    />
                    <TextField
                        size="small"
                        fullWidth
                        style={{ backgroundColor: 'white', marginTop: '30px' }}
                        disabled
                        label="Source"
                        value={entry?.source}
                    />
                    <TextField
                        size="small"
                        fullWidth
                        style={{ backgroundColor: 'white', marginTop: '30px' }}
                        disabled
                        label="Destination"
                        value={entry?.destination}
                    />
                    <TextField
                        size="small"
                        fullWidth
                        style={{ backgroundColor: 'white', marginTop: '30px' }}
                        disabled
                        label="Claim Number"
                        value={entry?.claimNumber}
                    />
                </Box>
                <Box
                    style={{ marginTop: '30px', borderRadius: '10px', backgroundColor: '#F2F6F9' }}
                >
                    <Box
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                        }}
                    >
                        <Typography style={{ padding: '30px' }} variant="h6">
                            Validation History
                        </Typography>
                    </Box>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Validation</TableCell>
                                <TableCell>Duration</TableCell>
                                <TableCell>Status</TableCell>
                                <TableCell>Details</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {logs.map((entry) => (
                                <Fragment key={entry.id}>
                                    <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
                                        <TableCell component="th" scope="row">
                                            {entry.validationType}
                                        </TableCell>
                                        <TableCell>{`${entry.duration} ms`}</TableCell>
                                        <TableCell>
                                            {(entry.status ?? '').toUpperCase() === 'SUCCESS' ? (
                                                <CheckCircle style={{ color: 'green' }} />
                                            ) : (
                                                <Cancel style={{ color: 'red' }} />
                                            )}
                                        </TableCell>
                                        <TableCell>
                                            <IconButton
                                                aria-label="expand row"
                                                size="small"
                                                onClick={() => {
                                                    if (expand === '' || expand !== entry.id) {
                                                        setExpand(entry.id)
                                                    } else {
                                                        setExpand('')
                                                    }
                                                }}
                                            >
                                                {expand === entry.id ? (
                                                    <KeyboardArrowUp />
                                                ) : (
                                                    <KeyboardArrowDown />
                                                )}
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell
                                            style={{ paddingBottom: 0, paddingTop: 0 }}
                                            colSpan={6}
                                        >
                                            <Collapse
                                                in={expand === entry.id}
                                                timeout="auto"
                                                unmountOnExit
                                            >
                                                <Box
                                                    style={{
                                                        marginTop: '20px',
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        alignItems: 'center',
                                                        justifyContent: 'space-between',
                                                    }}
                                                >
                                                    <Box
                                                        style={{
                                                            display: 'flex',
                                                            flexDirection: 'row',
                                                            alignItems: 'center',
                                                            justifyContent: 'space-between',
                                                        }}
                                                    >
                                                        <Typography
                                                            style={{
                                                                padding: '8px 0px 0px 8px',
                                                                alignItems: 'center',
                                                            }}
                                                            variant="h6"
                                                        >
                                                            Status{' '}
                                                            {(entry.status ?? '').toUpperCase() ===
                                                            'SUCCESS' ? (
                                                                <CheckCircle
                                                                    style={{ color: 'green' }}
                                                                />
                                                            ) : (
                                                                <Cancel style={{ color: 'red' }} />
                                                            )}
                                                        </Typography>
                                                    </Box>
                                                    <Box
                                                        style={{
                                                            display: 'flex',
                                                            flexDirection: 'row',
                                                            alignItems: 'center',
                                                            justifyContent: 'space-between',
                                                        }}
                                                    >
                                                        <Typography
                                                            style={{
                                                                padding: '4px 0px 0px 8px',
                                                                alignItems: 'center',
                                                            }}
                                                            variant="h6"
                                                        >{`Details ${(
                                                            entry.status ?? ''
                                                        ).toUpperCase()}`}</Typography>
                                                    </Box>
                                                    <Box
                                                        style={{
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            alignItems: 'center',
                                                            justifyContent: 'space-between',
                                                        }}
                                                    >
                                                        <Typography
                                                            style={{
                                                                padding: '8px 0px 0px 8px',
                                                                display: 'inline-block',
                                                                fontSize: '14px',
                                                                textAlign: 'center',
                                                            }}
                                                        >{`Duration: ${entry.duration} ms`}</Typography>
                                                        <Typography
                                                            style={{
                                                                padding: '8px 0px 0px 8px',
                                                                display: 'inline-block',
                                                                fontSize: '14px',
                                                                textAlign: 'center',
                                                            }}
                                                        >{`Request Sent (GMT): ${moment(
                                                            entry.createdOn,
                                                        ).format(
                                                            'MMMM Do yyyy, h:mm:ss a',
                                                        )}`}</Typography>
                                                        <Typography
                                                            style={{
                                                                padding: '8px 0px 0px 8px',
                                                                display: 'inline-block',
                                                                fontSize: '14px',
                                                                textAlign: 'center',
                                                            }}
                                                        >{`Response Received (GMT): ${moment(
                                                            entry.createdOn + entry.duration,
                                                        ).format(
                                                            'MMMM Do yyyy, h:mm:ss a',
                                                        )}`}</Typography>
                                                        <Typography
                                                            style={{
                                                                padding: '8px 0px 0px 8px',
                                                                display: 'inline-block',
                                                                fontSize: '14px',
                                                                textAlign: 'center',
                                                            }}
                                                        >{`URL: ${entry.endpoint}`}</Typography>
                                                        <Typography
                                                            style={{
                                                                padding: '8px 0px 0px 8px',
                                                                display: 'inline-block',
                                                                fontSize: '14px',
                                                                textAlign: 'center',
                                                            }}
                                                        >{`Response: Http Status Code ${entry.httpStatusCode}`}</Typography>
                                                    </Box>
                                                    <Box
                                                        style={{
                                                            marginTop: '20px',
                                                            display: 'flex',
                                                            flexDirection: 'row',
                                                            alignItems: 'center',
                                                            justifyContent: 'space-between',
                                                        }}
                                                    >
                                                        <IconButton
                                                            style={{ marginRight: '20px' }}
                                                            onClick={() =>
                                                                copyToClipboard(
                                                                    JSON.stringify(
                                                                        entry.requestContent,
                                                                    ),
                                                                )
                                                            }
                                                        >
                                                            <ContentCopy
                                                                style={{ color: 'black' }}
                                                            />
                                                            <Typography
                                                                style={{
                                                                    padding: '8px 0px 0px 8px',
                                                                    display: 'inline-block',
                                                                    fontSize: '14px',
                                                                    textAlign: 'center',
                                                                }}
                                                            >
                                                                Request
                                                            </Typography>
                                                        </IconButton>
                                                        <IconButton
                                                            onClick={() =>
                                                                copyToClipboard(
                                                                    JSON.stringify(
                                                                        entry.responseContent,
                                                                    ),
                                                                )
                                                            }
                                                        >
                                                            <ContentCopy
                                                                style={{ color: 'black' }}
                                                            />
                                                            <Typography
                                                                style={{
                                                                    padding: '8px 0px 0px 8px',
                                                                    display: 'inline-block',
                                                                    fontSize: '14px',
                                                                    textAlign: 'center',
                                                                }}
                                                            >
                                                                Response
                                                            </Typography>
                                                        </IconButton>
                                                    </Box>
                                                </Box>
                                            </Collapse>
                                        </TableCell>
                                    </TableRow>
                                </Fragment>
                            ))}
                        </TableBody>
                    </Table>
                </Box>
                <Box
                    style={{
                        marginTop: '20px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                    }}
                >
                    <Typography style={{ padding: '5px' }} variant="h6">{`Total Validation Time ${
                        logs === undefined
                            ? 0
                            : logs
                                  .map((item) => item.duration)
                                  .reduce((a, b) => {
                                      return a + b
                                  }, 0)
                    } ms`}</Typography>
                    <Typography style={{ padding: '5px' }} variant="h6">
                        Validation Status{' '}
                        {logs.every((e) => (e.status ?? '').toUpperCase() === 'SUCCESS') ? (
                            <CheckCircle style={{ color: 'green' }} />
                        ) : (
                            <Cancel style={{ color: 'red' }} />
                        )}
                    </Typography>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button
                    disableElevation={true}
                    variant="contained"
                    style={{ minWidth: '120px' }}
                    onClick={closeEvent}
                >
                    close
                </Button>
            </DialogActions>
        </Dialog>
    )
}
